<form [formGroup]="form" (ngSubmit)="onSubmit()" class="df-form" [class.df-form--horizontal]="isHorizontal">
  <h3 *ngIf="formTitle" class="df-title" style="margin:0 0 12px 0;">{{ formTitle }}</h3>
  <div *ngIf="schemaError" class="df-error" style="margin-bottom:12px; color:#b00020;">
    {{ schemaError }}
  </div>
  <ng-container *ngFor="let item of schema">
    <ng-container *ngIf="!item.group; else groupTpl">
      <div class="df-field" [class.form-row-horizontal]="isHorizontal">
        <label class="df-label" [class.col-label]="isHorizontal">{{ item.label }} <span *ngIf="item.required" class="req">*</span></label>
        <div [class.col-input]="isHorizontal">

        <!-- File Upload -->
        <div *ngIf="item.input === 'file'" class="file-upload-container mb-3">

          <!-- Instruction -->
          <div class="file-instruction-label df-file-helper">
            <span style="opacity: 0.7;">Select a file (*.csv, *.xlsx). Sample file </span>
            <a *ngIf="item.sampleUrl" class="file-instruction-label-link" [href]="item.sampleUrl"
              target="_blank">here</a>
          </div>

          <!-- File uploader -->
          <div class="file-uploader-container"
            [ngClass]="{ 'disabled': form.get(toKey(item.label))?.value && showPreview }">

            <!-- Choose File button -->
            <label class="file-uploader-label df-choose-btn" [attr.for]="toKey(item.label) + '_file_upload'">Choose
              File</label>

            <!-- Hidden file input -->
            <div class="file-uploader">
              <input type="file" class="df-hidden-file-input" [attr.id]="toKey(item.label) + '_file_upload'"
                [attr.name]="toKey(item.label)" [attr.accept]="item.accept || '.csv, .xls, .xlsx'"
                [attr.multiple]="item.multiple ? true : null" (change)="onFileSelectProxy(item, $event)" />
              <span class="file-name">{{ getFileName(item) || 'No file chosen' }}</span>
            </div>

            <!-- Add button (optional, still uses form submit pipeline) -->
            <button type="button" class="add-button df-btn df-btn-add" (click)="onFileAdd(item)" [ngClass]="{
              'btn-default': !form.get(toKey(item.label))?.value,
              'btn-selected': form.get(toKey(item.label))?.value
            }">
              {{ item.addLabel || 'Add' }}
            </button>
          </div>

          <!-- Validation errors -->
          <div class="df-file-error" *ngIf="form.get(toKey(item.label)) as c">
            {{ getError(item, c) }}
          </div>

          <!-- File Preview -->
          <div *ngIf="getFileName(item) && showPreview" class="file-preview-container">
            <span>{{ getFileName(item) }}</span>
            <img class="file-delete" src="assets/images/trash-can-outline.svg" (click)="deleteFile(item)" />
          </div>
        </div>

        <!-- Textbox -->
        <input
          *ngIf="(item.input === 'textbox' || item.input === 'password') && item.type !== 'number' && item.input !== 'datetime-local' && item.input !== 'date' && item.input !== 'time'"
          class="df-input" [class.error]="hasFieldError(item)"
          [type]="(item.input === 'password' || item.format === 'password') ? 'password' : 'text'"
          [formControlName]="toKey(item.label)" [placeholder]="placeholderOf(item)" />

        <!-- Number textbox -->
        <input *ngIf="item.input === 'textbox' && item.type === 'number'" type="number" class="df-input"
          [class.error]="hasFieldError(item)"
          [formControlName]="toKey(item.label)" [placeholder]="placeholderOf(item)" />

        <!-- DateTime -->
        <input *ngIf="item.input === 'datetime-local'" type="datetime-local" class="df-input"
          [formControlName]="toKey(item.label)" [attr.min]="item.minDate" [attr.max]="item.maxDate"
          [placeholder]="item.label" />

        <!-- Main error block for all field types -->
        <div class="df-error" *ngIf="form.get(toKey(item.label)) as c">
          {{ getError(item, c) }}
        </div>


        <!-- Date -->
        <input *ngIf="item.input === 'date'" type="date" class="df-input" [formControlName]="toKey(item.label)"
          [attr.min]="item.minDate" [attr.max]="item.maxDate" [placeholder]="item.label" />

        <!-- Time -->
        <input *ngIf="item.input === 'time'" type="time" class="df-input" [formControlName]="toKey(item.label)"
          [attr.min]="item.minTime" [attr.max]="item.maxTime" [placeholder]="item.label" />

        <!-- Dropdown -->
        <div *ngIf="item.input === 'dropdown'" class="df-multiselect-dropdown"
          [class.error]="hasFieldError(item)" [class.is-open]="item.dropdownOpen">
          <button type="button" class="df-multiselect-trigger" (click)="toggleDropdown(item); $event.stopPropagation()">
            <span class="df-multiselect-placeholder" *ngIf="!getSelectedSingleValue(item)">{{ placeholderOf(item) }}</span>
            <span class="df-multiselect-value" *ngIf="getSelectedSingleValue(item)">{{ getOptionLabelForValue(item, getSelectedSingleValue(item)) }}</span>
          </button>
          <div class="df-multiselect-panel" *ngIf="item.dropdownOpen" (click)="$event.stopPropagation()">
            <input type="text" class="df-multiselect-search"
              [value]="multiSearchQueries[toKey(item.label)] || ''"
              (input)="onMultiSearch(item, $event)"
              placeholder="Search" />
            <div class="df-multiselect-options">
              <button type="button" class="df-multiselect-option"
                *ngFor="let opt of filteredMultiOptions(item)"
                [class.selected]="isSingleSelected(item, opt)"
                (click)="selectSingleOption(item, opt, $event)">
                {{ optionLabelOf(item, opt) }}
              </button>
              <div class="df-multiselect-empty" *ngIf="!filteredMultiOptions(item).length">No matches</div>
            </div>
          </div>
        </div>

        <!-- Multi-select dropdown -->
        <div *ngIf="item.input === 'multi-select'" class="df-multiselect-dropdown"
          [class.error]="hasFieldError(item)" [class.is-open]="item.dropdownOpen">
          <button type="button" class="df-multiselect-trigger" (click)="toggleDropdown(item); $event.stopPropagation()">
            <span class="df-multiselect-placeholder" *ngIf="!getSelectedValues(item).length">{{ placeholderOf(item) }}</span>
            <span class="df-multiselect-chips" *ngIf="getSelectedValues(item).length">
              <span class="df-chip" *ngFor="let val of getSelectedValues(item)">
                {{ getOptionLabelForValue(item, val) }}
                <button type="button" class="df-chip-remove" (click)="removeMultiValue(item, val, $event)" aria-label="Remove">×</button>
              </span>
            </span>
          </button>
          <div class="df-multiselect-panel" *ngIf="item.dropdownOpen" (click)="$event.stopPropagation()">
            <input type="text" class="df-multiselect-search"
              [value]="multiSearchQueries[toKey(item.label)] || ''"
              (input)="onMultiSearch(item, $event)"
              placeholder="Search" />
            <div class="df-multiselect-options">
              <button type="button" class="df-multiselect-option"
                *ngFor="let opt of filteredMultiOptions(item)"
                [class.selected]="isMultiSelected(item, opt)"
                (click)="toggleMultiValue(item, opt, $event)">
                <span class="df-multiselect-check" [class.checked]="isMultiSelected(item, opt)"></span>
                {{ optionLabelOf(item, opt) }}
              </button>
              <div class="df-multiselect-empty" *ngIf="!filteredMultiOptions(item).length">No matches</div>
            </div>
          </div>
        </div>

        <!-- Textarea -->
        <div *ngIf="item.input === 'textarea'" class="df-textarea-wrapper">
          <textarea class="df-input df-textarea" [formControlName]="toKey(item.label)" [attr.rows]="item.rows || 8"
            [attr.placeholder]="item.placeholder || 'Enter ' + item.label">
          </textarea>
          <div class="df-error" *ngIf="form.get(toKey(item.label)) as c">
            {{ getError(item, c) }}
          </div>
        </div>
        <!-- Outbox-style Dropdown -->
        <div *ngIf="item.input === 'outbox-dropdown'" class="dropdown-container" [ngClass]="{ 'disabled': item.disabled }">
          <div class="input-container" (click)="toggleDropdown(item)">
            <input type="text" class="dropdown-input" [formControlName]="toKey(item.label)"
              [placeholder]="item.placeholder || 'Select ' + item.label" (focus)="openDropdown(item)" (blur)="closeDropdown(item)" readonly />
            <button *ngIf="form.get(toKey(item.label))?.value" class="clear-btn" (click)="clearDropdown(item, $event)"><img src="assets/images/close.svg"></button>
          </div>
          <img class="dropdown-arrow" [ngClass]="{'rotate-180': item.dropdownOpen}" src="assets/images/menu-down-dark.svg"
            alt="Dropdown Icon" (click)="toggleDropdown(item)" />
          <div class="dropdown-content" *ngIf="item.dropdownOpen && item.options?.length">
            <div class="dropdown-item" *ngFor="let option of item.options" (click)="selectDropdownOption(item, option)">
              {{ option.label || option }}
            </div>
          </div>
        </div>
        <!-- <div *ngIf="item.input === 'outbox-dropdown'" class="df-error" *ngIf="form.get(toKey(item.label)) as c"> -->
           <!-- {{ getError(item, c) }} -->
            <!-- {{ getError(item, form.get(toKey(item.label))) }}
        </div>  -->

        <div *ngIf="item.input === 'outbox-dropdown' && form.get(toKey(item.label))" class="df-error">
          {{ getError(item, form.get(toKey(item.label))) }}
        </div>
        
        <!-- Color Picker -->
        <div *ngIf="item.input === 'color'" class="df-field df-color-wrapper">
          <input type="color" class="df-color-input" [formControlName]="toKey(item.label)" />
        </div>

        <!-- Radio -->
        <div *ngIf="item.input === 'radio'" class="df-radio-group">
          <label *ngFor="let opt of item.options" class="df-radio">
            <input type="radio" [value]="opt" [formControlName]="toKey(item.label)" />
            <span>{{ opt }}</span>
          </label>
        </div>

        <!-- Checkbox -->
        <label *ngIf="item.input === 'checkbox'" class="df-checkbox">
          <input type="checkbox" [formControlName]="toKey(item.label)" />
          <span *ngIf="!isHorizontal">{{ item.label }}</span>
        </label>

        <!-- Switch -->
        <label *ngIf="item.input === 'switch'" class="df-switch">
          <input type="checkbox" [formControlName]="toKey(item.label)" />
          <span class="df-switch-slider"></span>
        </label>

        <!-- Segmented toggle (two options) -->
        <div *ngIf="item.input === 'segmented'" class="df-segmented" [ngStyle]="getSegmentedStyle(item)">
          <button type="button" class="df-segmented-btn"
            [class.is-active]="form.get(toKey(item.label))?.value === getSegmentValue(item, 0)"
            (click)="onSegmentedClick(item, 0)">{{ getSegmentLabel(item, 0) }}</button>
          <button type="button" class="df-segmented-btn"
            [class.is-active]="form.get(toKey(item.label))?.value === getSegmentValue(item, 1)"
            (click)="onSegmentedClick(item, 1)">{{ getSegmentLabel(item, 1) }}</button>
        </div>
        </div>
      </div>
    </ng-container>

    <!-- Group Template -->
    <ng-template #groupTpl>
      <fieldset class="df-group" [class.form-row-horizontal]="isHorizontal"
        [formGroupName]="(item.label && item.label.trim()) ? toKey(item.label) : null">
        <legend *ngIf="!isHorizontal && item.label && item.label.trim()">{{ item.label }}</legend>
        <span *ngIf="isHorizontal && item.label && item.label.trim()" class="df-label col-label">{{ item.label }} <span
            *ngIf="item.required" class="req">*</span></span>
        <ng-container *ngIf="item.input !== 'group-box'; else groupBoxTpl">
          <div [class.col-input]="isHorizontal">
          <ng-container *ngFor="let child of item.group">
            <div class="df-field">
              <label *ngIf="child.input !== 'checkbox'" class="df-label">{{ child.label }} <span *ngIf="child.required" class="req">*</span></label>
              <input *ngIf="child.input === 'textbox' && child.type !== 'number'" class="df-input"
                [formControlName]="toKey(child.label)" [placeholder]="child.label" />
              <input *ngIf="child.input === 'textbox' && child.type === 'number'" type="number" class="df-input"
                [formControlName]="toKey(child.label)" [placeholder]="child.label" />
              <select *ngIf="child.input === 'dropdown'" class="df-input" [formControlName]="toKey(child.label)">
                <option value="" disabled selected>Select {{ child.label }}</option>
                <option *ngFor="let opt of child.options" [value]="child.optionValue ? opt[child.optionValue] : opt">{{
                  child.optionLabel ? opt[child.optionLabel] : opt }}</option>
              </select>
              <div *ngIf="child.input === 'radio'" class="df-radio-group">
                <label *ngFor="let opt of child.options" class="df-radio"><input type="radio" [value]="opt"
                    [formControlName]="toKey(child.label)" /><span>{{ opt }}</span></label>
              </div>
              <label *ngIf="child.input === 'checkbox'" class="df-checkbox"><input type="checkbox"
                  [formControlName]="toKey(child.label)" /><span>{{ child.label }}</span></label>
              <div class="df-error" *ngIf="form.get(toKey(item.label)+'.'+toKey(child.label)) as cc">{{ getError(child,
                cc) }}</div>
            </div>
          </ng-container>
          </div>
        </ng-container>
      </fieldset>
    </ng-template>

    <ng-template #groupBoxTpl>
      <!-- With level -->
      <ng-container *ngIf="item.label && item.label.trim(); else noLevelGroupBox">
        <div class="df-groupbox" [formGroupName]="toKey(item.label)">
          <div class="df-groupbox-row">
            <div class="df-groupbox-col">
              <div class="df-subrow" *ngFor="let child of item.group; let i = index">
                <!-- Generic child renderer inside group-box -->
                <ng-container [ngSwitch]="child.input">
                  <select *ngSwitchCase="'dropdown'" class="df-input" [formControlName]="toKey(child.label)">
                    <option value="" disabled selected>Select {{ child.label }}</option>
                    <option *ngFor="let opt of child.options"
                      [value]="child.optionValue ? opt[child.optionValue] : opt">{{ child.optionLabel ?
                      opt[child.optionLabel] : opt }}</option>
                  </select>
                  <input *ngSwitchCase="'textbox'" class="df-input" [type]="child.type==='number' ? 'number' : 'text'"
                    [formControlName]="toKey(child.label)" [placeholder]="child.label" />
                  <input *ngSwitchCase="'date'" type="date" class="df-input" [formControlName]="toKey(child.label)" />
                  <input *ngSwitchCase="'time'" type="time" class="df-input" [formControlName]="toKey(child.label)" />
                  <input *ngSwitchCase="'datetime-local'" type="datetime-local" class="df-input"
                    [formControlName]="toKey(child.label)" />
                  <div *ngSwitchCase="'radio'" class="df-radio-group">
                    <label *ngFor="let opt of child.options" class="df-radio"><input type="radio" [value]="opt"
                        [formControlName]="toKey(child.label)" /><span>{{ opt }}</span></label>
                  </div>
                  <!-- <div *ngIf="child.input === 'radio'" class="df-radio-group">
                    <label *ngFor="let opt of child.options" class="df-radio"><input type="radio" [value]="opt" [formControlName]="toKey(child.label)" /><span>{{ opt }}</span></label>
                  </div> -->
                  <label *ngSwitchCase="'checkbox'" class="df-checkbox"><input type="checkbox"
                      [formControlName]="toKey(child.label)" /><span>{{ child.label }}</span></label>
                  <input *ngSwitchCase="'color'" type="color" class="df-input" [formControlName]="toKey(child.label)" />
                  <input *ngSwitchDefault class="df-input" [formControlName]="toKey(child.label)"
                    [placeholder]="child.label" />
                </ng-container>
              </div>
            </div>
            <div class="df-groupbox-actions">
              <button type="button" class="df-btn" (click)="onGroupSubmit(item)">ADD</button>
              <button type="button" class="df-btn df-btn-secondary" (click)="onGroupReset(item)">Cancel</button>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- No level -->
      <ng-template #noLevelGroupBox>
        <div class="df-groupbox">
          <div class="df-groupbox-row">
            <div class="df-groupbox-col">
              <div class="df-subrow" *ngFor="let child of item.group; let i = index">
                <ng-container [ngSwitch]="child.input">
                  <select *ngSwitchCase="'dropdown'" class="df-input" [formControlName]="toKey(child.label)">
                    <option value="" disabled selected>Select {{ child.label }}</option>
                    <option *ngFor="let opt of child.options"
                      [value]="child.optionValue ? opt[child.optionValue] : opt">{{ child.optionLabel ?
                      opt[child.optionLabel] : opt }}</option>
                  </select>
                  <input *ngSwitchCase="'textbox'" class="df-input" [type]="child.type==='number' ? 'number' : 'text'"
                    [formControlName]="toKey(child.label)" [placeholder]="child.label" />
                  <input *ngSwitchCase="'date'" type="date" class="df-input" [formControlName]="toKey(child.label)" />
                  <input *ngSwitchCase="'time'" type="time" class="df-input" [formControlName]="toKey(child.label)" />
                  <input *ngSwitchCase="'datetime-local'" type="datetime-local" class="df-input"
                    [formControlName]="toKey(child.label)" />
                  <div *ngSwitchCase="'radio'" class="df-radio-group">
                    <label *ngFor="let opt of child.options" class="df-radio"><input type="radio" [value]="opt"
                        [formControlName]="toKey(child.label)" /><span>{{ opt }}</span></label>
                  </div>
                  <label *ngSwitchCase="'checkbox'" class="df-checkbox"><input type="checkbox"
                      [formControlName]="toKey(child.label)" /><span>{{ child.label }}</span></label>
                  <input *ngSwitchCase="'color'" type="color" class="df-input" [formControlName]="toKey(child.label)" />
                  <input *ngSwitchDefault class="df-input" [formControlName]="toKey(child.label)"
                    [placeholder]="child.label" />
                </ng-container>
              </div>
            </div>
            <div class="df-groupbox-actions">
              <button type="button" class="df-circle success" (click)="onGroupSubmit(item)">Add</button>
              <button type="button" class="df-circle danger" (click)="onGroupReset(item)">Cancel</button>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </ng-container>

  <div class="df-actions" *ngIf="showActions">
    <button type="button" class="df-btn df-btn-secondary" [disabled]="!canReset" (click)="onReset()">{{ resetLabel ||
      'Reset' }}</button>
    <button type="submit" class="df-btn" [disabled]="!isFormReady()">{{ submitLabel || 'Submit' }}</button>
  </div>
</form>